<template>
    <k-panel class="border">
        <k-panel-header slot="header">{{ $t("addFunds") }}</k-panel-header>
        <ol class="list-decimal ml-4 text-sm" v-html="$t('addFundsDesc')">
        </ol>
    </k-panel>
</template>

<script>
    export default {};
</script>


